import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AcademicsRoutes from "components/routes/AcademicsRoutes";
import FinancesRoutes from "components/routes/FinancesRoutes";
import ServiceAlertRoutes from "components/routes/ServiceAlertRoutes";
import UserAuthRoutes from "components/routes/UserAuthRoutes";

import AdvisorUserOverviewPage from "components/pages/AdvisorUserOverviewPage";
import BillingDetailsPage from "components/pages/BillingDetailsPage";
import CampusPage from "components/pages/CampusPage";
import DashboardPage from "components/pages/DashboardPage";
import InactivePage from "components/pages/InactivePage";
import { SettingsPage } from "components/pages/SettingsPage";
import ToolboxPage from "components/pages/ToolboxPage";
import { PageTitle } from "components/ui/Page";
import NotFound404 from "components/ui/NotFound404";
import { CalCentralUpdateCard } from "components/cards/CalCentralUpdateCard";
import { DelegateWelcomePage } from "components/pages/DelegateWelcomePage";
import { useSlice } from "components/hooks/useSlice";

export default function RootRoutes() {
  const myStatus = useSlice("myStatus");
  const {
    actingAsUid,
    advisorActingAsUid,
    delegateActingAsUid,
    hasAcademicsTab,
    hasCampusTab,
    hasDashboardTab,
    hasFinancialsTab,
    hasToolboxTab,
  } = myStatus;

  return (
    <Routes>
      <Route path="/" element={<Navigate to={rootRedirect(myStatus)} />} />

      {hasAcademicsTab && (
        <Route path="academics/*" element={<AcademicsRoutes />} />
      )}

      <Route
        path="calcentral_update"
        element={
          <>
            <PageTitle title="CalCentral Update" />
            <CalCentralUpdateCard />
          </>
        }
      />

      {hasCampusTab && <Route path="campus/*" element={<CampusPage />} />}

      <Route path="billing/details" element={<BillingDetailsPage />} />

      {hasFinancialsTab && (
        <>
          <Route path="finances/*" element={<FinancesRoutes />} />
        </>
      )}

      {hasDashboardTab && (
        <Route path="dashboard" element={<DashboardPage />} />
      )}

      {!actingAsUid && !delegateActingAsUid && !advisorActingAsUid && (
        <Route path="delegate_welcome" element={<DelegateWelcomePage />} />
      )}

      <Route path="inactive/*" element={<InactivePage />} />
      <Route path="settings/*" element={<SettingsPage />} />
      <Route path="service_alerts/*" element={<ServiceAlertRoutes />} />

      {hasToolboxTab && (
        <>
          <Route path="toolbox" element={<ToolboxPage />} />
          <Route path="user_auths/*" element={<UserAuthRoutes />} />
        </>
      )}

      <Route path="user/overview/:uid" element={<AdvisorUserOverviewPage />} />

      <Route path="*" element={<NotFound404 />} />
    </Routes>
  );
}

function rootRedirect(myStatus) {
  const {
    hasAcademicsTab,
    hasCampusTab,
    hasDashboardTab,
    hasFinancialsTab,
    hasInactiveTab,
    hasToolboxTab,
  } = myStatus;

  return hasInactiveTab
    ? "inactive"
    : hasDashboardTab
    ? "dashboard"
    : hasAcademicsTab
    ? "academics"
    : hasFinancialsTab
    ? "finances"
    : hasCampusTab
    ? "campus"
    : hasToolboxTab && "toolbox";
}
